import { render, staticRenderFns } from "./results_old.vue?vue&type=template&id=8fefb108&scoped=true"
import script from "./results_old.vue?vue&type=script&lang=js"
export * from "./results_old.vue?vue&type=script&lang=js"
import style0 from "./results_old.vue?vue&type=style&index=0&id=8fefb108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fefb108",
  null
  
)

export default component.exports